import { useState } from "react";

export default function LocationSelectors({ onLocationChange }) {
  const [country, setCountry] = useState("");
  const [city, setCity] = useState("");

  const handleCountryChange = (e) => {
    const value = e.target.value;
    setCountry(value);
    onLocationChange({
      country: { value: value, label: value },
      city: { value: city, label: city },
    });
  };

  const handleCityChange = (e) => {
    const value = e.target.value;
    setCity(value);
    onLocationChange({
      country: { value: country, label: country },
      city: { value: value, label: value },
    });
  };

  return (
    <div className="space-y-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Country
        </label>
        <input
          type="text"
          value={country}
          onChange={handleCountryChange}
          placeholder="Enter your country"
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          required
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          City
        </label>
        <input
          type="text"
          value={city}
          onChange={handleCityChange}
          placeholder="Enter your city"
          className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent"
          required
        />
      </div>
    </div>
  );
}
